import { en } from './en'

export const en_GB = {
  translation: {
    'Welcome to React': 'Welcome to React and react-i18next',
    yesterday: 'Yesterday',
    today: 'Today',

    baseSettings: {
      profile: 'Profile',
      snippets: 'Snippets',
      phone: 'Phone',
      fax: 'Fax',
      notifications: 'Notifications',
      audio: 'Audio',
      blockedNumbers: 'Blocked Numbers',
      callCenter: 'Call Centre',
      experiments: 'Experiments',
      shortcutKeys: 'Shortcut Keys',
      collapse: 'Collapse',
      expand: 'Expand',
      new: 'New',
    },

    nav: {
      voicemail: 'Voicemail',
      calls: 'Calls',
      text: 'Text',
      messaging: 'Messaging',
      fax: 'Fax',
      contacts: 'Contacts',
      settings: 'Settings',
      webPhone: 'Web Phone',
      dashboard: 'Dashboard',
      analytics: 'Analytics',
    },

    global: {
      tooltip: {
        copyLink: 'Copy Link to Clipboard',
        copyLinkAt: 'Copy Link at {{timStamp}}',
        copyLinkText: 'Copy Link',
      },
      toast: {
        moveSuccess: 'Voicemail moved successfully.',
        moveError: 'Failed to move voicemail.',
        deleteSuccess: 'Voicemail deleted successfully.',
        deleteError: 'Failed to delete voicemail.',
        markUnreadSuccess: 'Voicemail marked as unread.',
        markUnreadError: 'Failed to mark voicemail as unread.',
        copyLinkSuccess: 'Link Copied to Clipboard',
        copySuccess: 'Copied to clipboard',
        copyError: 'Unable to copy to clipboard',
        extensionSwitched: 'Extension switched to:',
        pbxChanged: 'PBX changed to:',
      },
      input: {
        defaultPlaceholder: 'Type here',
      },
    },

    contactSearchInput: {
      placeholder: 'Type a name or number',
      invalidPhoneNumber: 'Invalid phone number',
    },

    newCallModal: {
      header: 'New Call',
      sendToWebPhone: 'Send to Web Phone',
      sendToDeskPhone: 'Send to Desk Phone (Yealink)',
      from: 'From',
      to: 'To',
      answerHandsetWhenItRings: 'Answer your handset when it rings.',
      attemptingToEstablishCallTo:
        'Attempting to establish call to {{phoneNumber}}...',
      checkInternetConnection:
        'Please check your internet connection and try again.',
      tryAgain: 'Try Again',
      establishingCallTo: 'Establishing call to {{phoneNumber}}...',
    },

    confirmBlockNumberModal: {
      title: 'Block {{formattedPhoneNumber}}',
      message:
        'Your PBX will no longer receive calls, texts or faxes from this number.',
      confirmText: 'Block Number',
      cancelText: 'Cancel',
      toastBlockError:
        'There was a problem blocking {{formattedPhoneNumber}}, please try again.',
      toastUnblockError:
        'There was a problem unblocking {{formattedPhoneNumber}}, please try again.',
    },

    blockedNumbers: {
      addNumber: 'Add Number',
      headerSubtext:
        'All calls, texts, and faxes from the numbers listed below will be blocked.',
      header: 'Blocked Numbers',
      clearButton: 'Clear',
      blockButton: 'Block Number',
      modalSubtext:
        'All calls, texts, and faxes from the numbers listed below will be blocked.',
    },

    messageInput: {
      statusMessage: {
        uploading: 'Uploading...',
        failedToUpload: 'Failed to upload',
      },
      attachMedia: 'Attach Media',
      addSnippet: 'Add Snippet',
      emojis: 'Emojis 😃',
      sendText: 'Send Text',
    },

    messagingPage: {
      emptyDetailViewMessage: 'No Thread Selected',
      errorToastMessage: 'Invalid phone number',
      textPlaceholder: {
        receivedFile: 'Received File',
        fileSent: 'File Sent',
      },
      subheadingText: '{{phoneNumber}} from',
    },

    newFaxModal: {
      header: 'New Fax',
      footer: {
        sendButtonText: 'Send',
      },
      loadingView: {
        sendingFax: 'Sending fax...',
      },
    },

    newFaxForm: {
      dropdownPlaceholder: 'From...',
      textAreaPlaceholder: 'Enter cover page note',
      switchText: {
        includeCoverPage: 'Include Cover Page',
        sendEmailConfirmation: 'Send Email Confirmation',
      },
      dropzonePlaceholder: 'You can send up to 25mb Faxes',
      tagInputPlaceholder: 'Enter email address and press "Enter"',
      tagInputGuideText:
        'You can submit up to {{maxEmailConfirmations}} email addresses',
    },

    sizeGauge: {
      totalSize: 'Total Size: {{totalSize}} / {{sizeLimit}}',
      exceededSize: 'Exceeded by {{exceededSize}}',
    },

    contentDefault: {
      placeholder: 'Drag and drop file here, or click to browse',
    },

    newThreadModal: {
      header: {
        newThread: 'New Thread',
        noGroupFound: 'No Group Found',
      },
      sendButtonText: 'Send',
      contactText1: 'This extension is not part of a messaging group.',
      contactText2:
        'Head over to admin.mangovoice.com and set up your messaging group, or contact your Mango Adminstrator',
      contactLinkText: 'What is a Messaging Group?',
      placeholder: 'Your message',
    },

    deleteConfirmModal: {
      title: 'Delete Voicemail?',
      message: 'This is permanent and cannot be undone.',
      deleteButton: 'Delete',
      cancelButton: 'Cancel',
    },

    emptySearch: {
      shoot: 'Shoot.',
      nothingIsMatching: 'Nothing is matching',
      didYouSpellItRight: 'Did you spell it right?',
    },

    messageThreadHeader: {
      rename: 'Rename',
      cancel: 'Cancel',
    },

    dropZoneMappings: {
      fileToLarge: {
        title: 'File Too Large',
        description:
          "Looks like the file you're trying to upload is too large. Max file size is {{maxFileSize}}MB",
      },
      fileInvalidType: {
        link: 'Learn more',
        title: 'Unsupported File Type',
        faxDescription: `Looks like that file is an unsupported file type. {{link}} about supported file types`,
        description: `Looks like that file is an unsupported file type. Learn more about supported file types at {{urlLink}}`,
      },
      fileUploadFailed: {
        title: 'Upload Failed',
        description:
          "Looks like the file you're trying to upload failed to upload. Please try again.",
      },
      general: {
        title: 'An unexpected error has occurred',
        description: 'An unexpected error has occurred, please try again.',
      },
    },

    messageThreads: {
      emptyState: {
        title: 'No Texts',
        subtitle1: 'You haven’t sent or received any texts yet',
        subtitle2: 'Send a text to get started',
      },
      searchPlaceholder: 'Search a name or number',
      allGroups: 'All Groups',
      new: '{{count}} New - see all',
      markAllRead: 'Mark All Read',
      buttonText: 'New Text',
    },

    search: {
      placeholder: 'Search a name or number',
    },

    phoneOptions: {
      recent: 'Recent',
      missed: 'Missed',
    },

    chatOptions: {
      recent: 'Recent',
      unread: 'Unread',
    },

    snippetOptions: {
      pbx: 'PBX',
      personal: 'Personal',
    },

    chatMenu: {
      label: 'Snippets',
    },

    phoneMenu: {
      label: 'Auto Answer',
    },

    generalMenu: {
      label: 'Send Feedback',
    },

    experimentsMenu: {
      label: 'Web Phone',
    },

    developMenu: {
      notifications: 'Notifications',
      contacts: 'Contacts',
    },

    callState: {
      inboundAnswered: 'Inbound Answered',
      outboundAnswered: 'Outbound Answered',
      inboundMissedOrDeclined: 'Inbound Missed or Declined',
      outboundMissedOrDeclined: 'Outbound Missed or Declined',
    },

    voicemailState: {
      received: 'Received a voicemail',
      sent: 'You left a voicemail',
    },

    voicemailOptions: {
      recent: 'Recent',
      unread: 'Unread',
    },

    mangoPhoneTypes: {
      mobile: 'Mobile',
      work: 'Work',
      home: 'Home',
    },

    mangoContactTypes: {
      mango: 'Mango Voice',
    },

    markReadModal: {
      header: 'Caution - Mark All Read',
      message: 'Marking all threads as read can NOT be undone',
      confirmText: 'Are you sure?',
      confirmButton: 'Confirm',
    },

    faxViewList: {
      titleNoFaxes: 'No Faxes',
      titleNoMatchingFaxes: 'No Matching Faxes',
      subtitleTryRemovingFilters: 'Try removing some filters',
      subtitleNoFaxes: "Looks like you don't have any faxes.",
      buttonTextStartFax: 'Start a Fax',
      buttonTextStartFirstFax: 'Start your first Fax',
      searchPlaceholder: 'Search a name or number',
      status: {
        failed: 'Failed',
        pending: 'Processing',
        sent: 'Sent',
        received: 'Received',
        unknown: 'Unknown',
      },
    },

    pdfToolbar: {
      print: 'Print',
      download: 'Download',
      openInNewTab: 'Open in New Tab',
    },

    toolbar: {
      page: 'Page',
      clearAll: 'Clear All',
      potentialDuplicates: 'Potential Duplicates',
    },

    call: {
      toast: {
        callDeclined: 'Call from {{context}} declined',
        callEnded: 'Call with {{context}} ended',
        callHeld: 'Call with {{context}} held',
        callParked: '{{callName}} transferred to {{parkingLotName}}',
        callTransferred: '{{callName}} transferred to {{transferToName}}',
      },
    },

    incomingCallModal: {
      newCallFrom: 'New Call From',
      rejectCall: 'Reject Call',
      acceptCall: 'Accept Call',
      endAndAccept: 'End & Accept',
      holdAndAccept: 'Hold & Accept',
      parkAndAccept: 'Park & Accept',
    },

    faxPage: {
      toast: {
        copyLinkSuccess: 'Link Copied to Clipboard',
        copyLinkError: 'Failed to copy link to clipboard.',
        sendSuccess:
          'Your fax has been added to the queue and will be sent shortly',
        sendError: 'There was a problem sending your fax. Please try again',
        deleteSuccess: 'Fax deleted successfully',
        deleteError: 'There was a problem deleting this fax. Please try again',
      },
      confirmDelete: {
        title: 'Delete Fax',
        message: 'Are you sure you want to delete this fax?',
        button: 'Delete',
        cancel: 'Cancel',
      },
      confirmResend: {
        title: 'Resend Fax',
        message: 'Are you sure you want to resend this fax?',
        button: 'Resend',
        cancel: 'Cancel',
      },
      emptyStateMessage: 'No Fax Selected',
      status: {
        queued: 'Queued',
        received: 'Received',
        sent: 'Sent',
      },
      direction: {
        to: 'To',
        from: 'From',
      },
      detailsHeader: {
        status:
          '{{statusPrefix}} on {{statusDate}} at {{statusTime}} {{directionText}}',
      },
    },

    voicemail: {
      emptyState: {
        title: 'No Voicemails',
        subtitle1:
          "Looks like you're answering all of your calls. Keep up the good work!",
        subtitle2:
          "If you think you're missing voicemails, please contact our support team.",
        buttonText: 'Contact Support',
      },
      searchPlaceholder: 'Search for a caller name or number',
      emptyDetailViewMessage: 'No Voicemail Selected',

      mangoModal: {
        title: 'Move',
        headerText: 'Move Voicemail',
        cancelButtonText: 'Cancel',
        moveButtonText: 'Move Voicemail',
        selectVoicemailBoxText: 'Select Voicemail Box...',
        markAsUnreadText: 'Mark as unread in the selected box',
        destinationBoxText: 'Destination Voicemail Box',
        destinationBoxWarning:
          "This voicemail will become unavailable if you don't have access to the destination Voicemail Box.",
      },

      detailView: {
        headerSubheadingText: 'From',
        headerSubheadingToText: 'To',
        audioPlayerTitle: 'Voicemail Audio',
        transcriptionText: 'Transcription',
      },

      quickActions: {
        rewind10s: 'Rewind 10s',
        play: 'Play',
        pause: 'Pause',
        mute: 'Mute',
        unmute: 'Unmute',
        fastForward10s: 'Fast Forward 10s',
        jumpToAnswer: 'Jump to Answer',
        changePlaybackSpeed: 'Change Playback Speed',
        downloadAudio: 'Download Audio',
        seeKeyboardShortcuts: 'See Keyboard Shortcuts',
      },

      loadingText: 'Voicemail',
      transcriptionTitleText: 'Transcription',

      move: {
        error: 'An error occurred while moving the voicemail.',
        success: 'Voicemail successfully moved',
        successMarkAsUnread:
          'Voicemail successfully moved and marked as unread',
        successMarkAsRead: 'Voicemail successfully moved',
      },

      filter: {
        all: 'All',
        unread: 'Unread',
        allInboxes: 'All Inboxes',
      },

      tooltip: {
        move: 'Move',
        delete: 'Delete',
        markAsUnread: 'Mark as unread',
        markAsRead: 'Mark as read',
        blockNumber: 'Block number',
        unblockNumber: 'Unblock number',
        copyLink: 'Copy Link to Clipboard',
        editContact: 'Edit Contact',
        newCall: 'New Call',
        newText: 'New Text',
        resendFax: 'Resend Fax',
        moveFax: 'Move Fax',
        newFax: 'New Fax',
        close: 'Close',
      },

      copyLinkError: 'Failed to copy link to clipboard.',
    },

    fax: {
      filter: {
        all: 'All',
        unread: 'Unread',
        allInboxes: 'All Inboxes',
        sent: 'Sent',
        received: 'Received',
      },
      tooltip: {
        pending: 'This fax is processing and will be sent shortly',
      },
    },
  },
  support_phone_label: 'Support Hotline: {{phoneNumber, phone}}',
  user_profile_phone: 'Your registered phone number is: {{userPhone, phone}}',
} satisfies typeof en
